export const calculateDiscountPercentage = (basePrice: number, price: number) => {
  return Math.floor(((basePrice - price) / basePrice) * 100);
};
